/* eslint-disable no-param-reassign */
import type { PayloadAction } from '@reduxjs/toolkit';

import { createSlice } from '@reduxjs/toolkit';

import type { CoopContentPageSize } from '../../../../../utility/coopSwiperBreakpoints';
import type { PriceType } from '../../../models/priceData/priceData';
import type { SharedUiState } from '../../structureDefinitions/uiState';

import { appConfig } from '../../../../../appConfig';
import persistance from '../../../persistance/persistance';

interface LayoutSizePayload {
    size: CoopContentPageSize;
}

interface PriceTypePayload {
    preferredPriceType: PriceType;
}

const getInitialState = (): SharedUiState => {
    const userId = appConfig.coopUserSettings.shoppingUserId;
    const preferredPriceType = persistance.priceTypeStorage.getCurrent(userId);

    let defaultSharedUiState: SharedUiState = {
        hasSideBar: false,
        hideFooterMobile: false,
        hideSubMenu: false,
        layoutSize: 'default',
        contentPageSize: 'default',
        preferredPriceType,
    };

    const domProps = document.getElementById('layoutSettings')?.innerText;
    if (domProps) {
        const parsedLayoutSettings = JSON.parse(domProps) as Partial<SharedUiState>;
        if (parsedLayoutSettings) {
            defaultSharedUiState = { ...defaultSharedUiState, ...parsedLayoutSettings };
        }
    }

    return defaultSharedUiState;
};

const slice = createSlice({
    name: 'shared',
    initialState: getInitialState(),
    reducers: {
        setContentPageSize: (state: SharedUiState, action: PayloadAction<LayoutSizePayload>) => {
            return { ...state, contentPageSize: action.payload.size };
        },
        setPriceType: (state: SharedUiState, action: PayloadAction<PriceTypePayload>) => {
            return { ...state, preferredPriceType: action.payload.preferredPriceType };
        },
    },
});

const actions = { ...slice.actions };
export const sharedUiActions = actions;

export default slice.reducer;
